module.exports = __webpack_public_path__ + "static/media/twittericon.37bc18d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/twittericon.png
// module id = 1435
// module chunks = 0